import { TAG } from "../constants";
import {
  AnswerQueryArgs,
  AnswerResponse,
  AnswerType,
  SubmitAnswerArgs,
} from "../types";
import { patientApi } from "./patientApi";
import { visitApi } from "./visitApi";

export const answersApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    //answers
    getAnswer: builder.query<AnswerType | null, AnswerQueryArgs>({
      query: ({ visitId, questionId }) => ({
        method: "GET",
        url: `/api/patient/visits/${visitId}/answers/${questionId}`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAG.ANSWER, id: args.questionId },
      ],
    }),

    getAnswers: builder.query<Record<string, AnswerResponse>, string>({
      query: (visitId) => ({
        method: "GET",
        url: `/api/patient/visits/${visitId}/answers`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAG.ANSWERS, id: args },
      ],
    }),

    submitAnswer: builder.mutation<AnswerType, SubmitAnswerArgs>({
      query: ({ visitId, ...body }) => ({
        method: "POST",
        url: `/api/patient/visits/${visitId}/answers`,
        body,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          visitApi.util.updateQueryData("getVisit", args.visitId, (draft) => {
            if (!draft.answers) draft.answers = [];

            const index = draft.answers.findIndex(
              (a) => a.question_id === args.question_id
            );

            if (index >= 0) {
              draft.answers.splice(index, 1, {
                question_id: args.question_id,
                response: args.response,
              });
            } else {
              draft.answers.push({
                question_id: args.question_id,
                response: args.response,
              });
            }
          })
        );

        queryFulfilled.catch(patch.undo);
      },
    }),
  }),
});

export const {
  useGetAnswerQuery,
  useSubmitAnswerMutation,
  useGetAnswersQuery,
} = answersApi;
